const { produce } = require("immer");
const {
  writeIndex,
  updateElements,
  deleteElements,
  updateAllElements,
  deleteAllElements,
  requestFailed,
  retrySuccess,
  retryInvalid,
  subReducers,
  streamProgress,
  clearStreamProgress,
} = require("./methods");

function initIndex(index) {
  return Object.keys(index).reduce((acc, k) => {
    acc[k] = {};
    return acc;
  }, {});
}

module.exports = function (state = {}, action, reducers = null) {
  switch (action.type) {
    case "ADD_WORKSPACE":
      return produce(state, draft => {
        let projectUid = action.uid;
        Object.keys(action.index).forEach(licenceUid => {
          if (!(projectUid in draft)) draft[projectUid] = {};
          let ws = draft[projectUid];
          if (!(licenceUid in ws)) ws[licenceUid] = {};
          let wsApp = ws[licenceUid];
          if (!wsApp.data) {
            if (reducers) wsApp.data = reducers.data(wsApp.data, action, state);
            else wsApp.data = {}
          }
          if (!wsApp.local) {
            if (reducers) wsApp.local = reducers.local(wsApp.local, action, state);
            else wsApp.local = {};
          }
          if (!wsApp.shared) {
            if (reducers) wsApp.shared = reducers.shared(action.index[licenceUid].shared, action, state);
            else wsApp.shared = action.index[licenceUid].shared || {};
          }
          // if(!wsApp.setting && reducers) {
          //   if(reducers) wsApp.setting = reducers.setting(action.index[licenceUid].setting, action, state);
          //   else wsApp.setting = action.index[licenceUid].setting;
          // }
          let init = initIndex(action.index[licenceUid].index);
          if (!wsApp.index) wsApp.index = init;
          if (!wsApp.failed) wsApp.failed = []
          wsApp.init = action.index[licenceUid].index;
          if (!wsApp.streamProgress) wsApp.streamProgress = {}
        });
      });
    case "WORKSPACE_WRITE_INDEX":
      return writeIndex(state, action);
    case "WORKSPACE_UPDATE_ELEMENTS":
      return updateElements(state, action);
    case "WORKSPACE_DELETE_ELEMENTS":
      return deleteElements(state, action);
    case "WORKSPACE_UPDATE_ALL_ELEMENTS":
      return updateAllElements(state, action);
    case "WORKSPACE_DELETE_ALL_ELEMENTS":
      return deleteAllElements(state, action);
    case "WORKSPACE_REQUEST_FAILED":
      return requestFailed(state, action)
    case "WORKSPACE_RETRY_SUCCESS":
      return retrySuccess(state, action)
    case "WORKSPACE_RETRY_INVALID":
      return retryInvalid(state, action)
    case "WORKSPACE_STREAM_PROGRESS":
      return streamProgress(state, action)
    case "WORKSPACE_CLEAR_STREAM":
      return clearStreamProgress(state, action)

    default: {
      if (action.type === "WORKSPACE_UPDATED") {
        return subReducers(produce(state, draft => {
          if (action.projectUid in draft) {
            draft[action.projectUid].users = action.users
          }
        }), action, reducers)
      }
      return subReducers(state, action, reducers)
    }
  }
}